setTimeout(() => {
  document.querySelectorAll('.mega-menu__item').forEach(item => {
    const submenu = item.querySelector('ul');

    if (submenu) {
      // Prevent duplicate arrows
      if (item.querySelector('.submenu-toggle')) return;

      // Create arrow
      const arrow = document.createElement('span');
      arrow.textContent = '>';
      arrow.classList.add('submenu-toggle');
      Object.assign(arrow.style, {
        cursor: 'pointer',
        fontSize: '16px',
        userSelect: 'none',
        display: 'inline-block',
      });

      // Insert arrow after the main link
      const link = item.querySelector('a');
      if (link) link.after(arrow);

      // Style submenu (hide initially)
      Object.assign(submenu.style, {
       display: 'none',
          position: 'absolute',
          top: '0',
          left: '337px',
          background: '#fff',
          zIndex: '999',
          minWidth: '280px',
          padding: '20px',
      });

      // Toggle submenu on arrow click
      arrow.addEventListener('click', function (e) {
        e.stopPropagation();

        const isOpen = item.classList.contains('open');

        // Close all other open submenus
        document.querySelectorAll('.mega-menu__item.open').forEach(openItem => {
          openItem.classList.remove('open');
          const openSub = openItem.querySelector('ul');
          if (openSub) openSub.style.display = 'none';
        });

        if (isOpen) {
          item.classList.remove('open');
          submenu.style.display = 'none';
        } else {
          item.classList.add('open');
          submenu.style.display = 'block';
        }
      });
    }
  });

  // Close on click outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.mega-menu__item')) {
      document.querySelectorAll('.mega-menu__item.open').forEach(item => {
        item.classList.remove('open');
        const submenu = item.querySelector('ul');
        if (submenu) submenu.style.display = 'none';
      });
    }
  });
}, 1000); // Wait for 1 second in case menu loads late


// Vat price
setTimeout(function () {
  const container = document.querySelector(".price__container");

  if (container && container.children.length === 0) {
    const comparePriceNoVat = container.querySelector(".bss-b2b-compare-price-no-vat");
    const comparePriceHasVat = container.querySelector(".bss-b2b-compare-price-has-vat");
    const priceNoVat = container.querySelector(".bss-b2b-price-no-vat");
    const priceHasVat = container.querySelector(".bss-b2b-price-has-vat");

    const compareWrapper = document.createElement("div");
    const priceWrapper = document.createElement("div");

    if (comparePriceNoVat && comparePriceHasVat) {
      compareWrapper.appendChild(comparePriceNoVat);
      compareWrapper.appendChild(document.createTextNode(" "));
      compareWrapper.appendChild(comparePriceHasVat);
    }

    if (priceNoVat && priceHasVat) {
      priceWrapper.appendChild(priceNoVat);
      priceWrapper.appendChild(document.createTextNode(" "));
      priceWrapper.appendChild(priceHasVat);
    }

    // Only clear if needed
    container.innerHTML = "";
    if (compareWrapper.childNodes.length > 0) container.appendChild(compareWrapper);
    if (priceWrapper.childNodes.length > 0) container.appendChild(priceWrapper);
  }
}, 1000);


// description
document.addEventListener("DOMContentLoaded", function () {
  const description = document.querySelector(".clamp-text");
  const toggleBtn = document.querySelector(".toggle-description-btn");

  if (description && toggleBtn) {
    toggleBtn.addEventListener("click", function () {
      description.classList.toggle("expanded");
      toggleBtn.textContent = description.classList.contains("expanded") ? "Luk" : "Læs mere";
    });
  }
});

// Card unique class

setTimeout(function () {
  const priceContainers = document.querySelectorAll(".card-information > .price__container");

  priceContainers.forEach((container) => {
    const children = container.children;

    Array.from(children).forEach((child, index) => {
      const nthClass = `price-child-${index + 1}`;
      child.classList.add(nthClass);
    });
  });
}, 1000);

setTimeout(function () {
  const priceContainers = document.querySelectorAll(".price__container");

  priceContainers.forEach((container, containerIndex) => {
    // Add a unique class to .price__container itself
    container.classList.add(`price__container-${containerIndex + 1}`);

    // Add unique classes to each child
    Array.from(container.children).forEach((child, childIndex) => {
      child.classList.add(`price-child-${childIndex + 1}`);
    });
  });
}, 1000);


